module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Loading', {
    attrs: {
      "show": _vm.loading,
      "text": _vm.$t('general.cancelling')
    }
  }), _vm._v(" "), _c('div', {
    class: {
      loading: _vm.loading
    }
  }, [(!_vm.purchaseCompleted) ? _c('div', {
    staticClass: "cancel-info"
  }, [_c('p', [_c('span', {
    attrs: {
      "id": "cancel-info-span"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.fill-details')))]), _c('br'), _c('button', {
    staticClass: "small white border",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.payment.cancel')))])])]) : _vm._e(), _vm._v(" "), (!_vm.purchaseCompleted) ? _c('div', {
    staticClass: "danish-info"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "0.5em 1em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('general.contact_guest_service.payment', {
        phone: '<a href=\'tel:054-13 26 00\'>054-13 26 00</a>'
      }))
    }
  })]) : _vm._e(), _vm._v(" "), _c('BookingTimer', {
    attrs: {
      "currently-paying": true
    },
    on: {
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.SITE_CONFIG.payment_service === 'klarna') ? _c('KlarnaCheckout') : (_vm.SITE_CONFIG.payment_service === 'collector') ? _c('CollectorCheckout', {
    on: {
      "purchase-completed": _vm.handlePurchaseCompleted
    }
  }) : _c('div', [_vm._v("There’s no configured payment service (" + _vm._s(_vm.SITE_CONFIG.payment_service) + ")")])], 1), _vm._v(" "), _c('OrderCheckForCancellation')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45a14b7b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PaymentPage.vue
// module id = 980
// module chunks = 0